import { render, staticRenderFns } from "./dic_unit_edit.vue?vue&type=template&id=4567add2&scoped=true"
import script from "./dic_unit_edit.vue?vue&type=script&lang=js"
export * from "./dic_unit_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4567add2",
  null
  
)

export default component.exports